<section class="auction-batch-details">
  <div class="container-fluid">
    <div class="card auction-content-main m-0">
      <div class="auction-content-body position-relative p-4">
        <div class="row auction-batch-details__basicInfoWrapper mx-0 mb-5">
          <!-- Batch image -->
          <div class="auction-batch-details__imageViewer">
            <ng-container
              *ngIf="batchInfo?.['batchImageUrl']?.[0]?.['presigned_url']; else placeholderImage"
            >
              <img
                src="{{batchInfo?.['batchImageUrl']?.[0]?.['presigned_url']}}"
              />
            </ng-container>

            <ng-template #placeholderImage>
              <img src="/assets/img/car-placeholder.png" />
            </ng-template>
          </div>

          <div class="auction-batch-details__basicInfo px-md-3">
            <div class="auction-batch-details__infos">
              <div class="info-row mb-2">
                <h4 class="fs-md fw-500 color-ashen-med">
                  Batch Name :
                  <span class="fs-md fw-400">
                    {{ batchInfo?.['group_name'] || '--' }}
                  </span>
                </h4>
              </div>

              <div class="info-row mb-2">
                <h4 class="fs-md fw-500 color-ashen-med">
                  Batch ID :
                  <span class="fs-md fw-400">
                    {{ batchInfo?.['id'] || '--' }}
                  </span>
                </h4>
              </div>

              <div class="info-row mb-2">
                <h4 class="fs-md fw-500 color-ashen-med">
                  Total Vehicles :
                  <span class="fs-md fw-400">
                    {{ batchInfo?.['totalNoOfVehicles'] || '--' }}
                  </span>
                </h4>
              </div>

              <div class="info-row mb-0">
                <h4 class="fs-md fw-500 color-ashen-med">
                  Location :
                  <span class="fs-md fw-400">
                    {{ batchInfo?.['location'] || '--' }}
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div class="auction-batch-details__batches">
          <div class="d-flex mb-3 align-items-center justify-content-between">
            <div class="auction-batch-details__search">
              <label class="credential2__label"> Product Added </label>
            </div>

            <div class="dt-client-side-search">
              <input
                type="text"
                (keyup)="searchVehicle($event, 1)"
                class="searchable-column"
                placeholder="Type a Make"
              />

              <input
                type="text"
                (keyup)="searchVehicle($event, 5)"
                class="searchable-column"
                placeholder="Type a VIN"
              />

              <input
                type="text"
                (keyup)="searchVehicle($event, 6)"
                class="searchable-column"
                placeholder="Type a Registration"
              />
            </div>
          </div>

          <div>
            <p *ngIf="!tableData.length" class="m-0">No data found</p>
            <table
              datatable
              [dtOptions]="dtOptions"
              id="batch-vehicles"
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th *ngFor="let thead of theads">{{ thead }}</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
